import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server from "../../api/server";
import SlidersArray from "../../components/values/SliderArray";

const ValuesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "القيم ",
				breadcrumb: "القيم",
				button: {
					show: false,
					text: "اضافة معلومة جديدة",
					link: "/siteinfo/aboutUs/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get(
				"/pages/about-us/sections/values"
			);

			setData(pageData.data.data.section?.sections || []);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			console.log("error", error);
			setLoading(false);
		}
	};

	// const handleDelete = postID => {
	// 	axios
	// 		.delete(
	// 			`${process.env.REACT_APP_API_URL}/pages/values/sections/${postID}`,
	// 			{
	// 				headers: {
	// 					Authorization: `Bearer ${cookie.get("token")}`,
	// 					Accept: "application/json",
	// 				},
	// 			}
	// 		)
	// 		.then(function (response) {
	// 			onStart();
	// 		})
	// 		.catch(function (error) {
	// 			toast.error("خطأ، برجاء المحاولة لاحقا!");
	// 		});
	// };
	const onSubmit = async () => {
		// data.content = sliders.reduce((result, current) => {
		//   // const key = Object.keys(current)[0];
		//   result[`section${index}`] = current;
		//   index++;
		//   return result;
		// }, {});
		setLoading(true);
		try {
			await server(cookie).put(`/pages/about-us/sections/values`, {
				section: { sections: data },
			});
		} catch (error) {
			console.log(error);
		}
		setLoading(false);

		// dispatch(editPage({ slug: singlePage?.slug, data, navigate }));
	};
	return (
		<section>
			{loading && <Loader />}
			<section>
				<SlidersArray sliders={data} setSliders={setData} />
			</section>
			<br />
			<hr />
			<br />
			<button className="btn btn-success px-5 fw-bold" onClick={onSubmit}>
				حفظ
			</button>
		</section>
	);
};

export default ValuesIndex;
